import React, { useState } from 'react';
import { CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { SvgIcon } from '@progress/kendo-react-common';
import { HeaderThElement } from '@progress/kendo-react-data-tools';
import { GridCustomFilterCellProps, GridFilterChangeEvent } from '@progress/kendo-react-grid';
import { InputPrefix } from '@progress/kendo-react-inputs';
import { searchIcon } from '@progress/kendo-svg-icons';
import CardGrid from '@components-clean/core/grid/card-grid';
import { GridColumnProps } from '@components-clean/core/grid/grid.interface';
import { MultiValueDataCell } from '@components-clean/core/grid-fe/custom-cells';
import { TextBox } from '@components-clean/core/text-box';
import { NonRAGGridDummyData } from '@pages-clean/dummy-page/dummy-page.data';

const FilterCustomCell = ({ thProps, onChange }: GridCustomFilterCellProps) => {
    return (
        <HeaderThElement columnId={thProps?.columnId || ''} {...thProps}>
            <TextBox
                data-testid={`filter-textbox-${thProps?.columnId ?? ''}`}
                fillMode="flat"
                prefix={() => (
                    <InputPrefix className="k-display-flex k-align-items-center">
                        <SvgIcon icon={searchIcon} size="large" />
                    </InputPrefix>
                )}
                placeholder=" "
                onChange={(event) => {
                    const hasValue = event.target.value !== '';
                    onChange({
                        value: hasValue ? String(event.target.value) : '',
                        operator: hasValue ? 'eq' : '',
                        syntheticEvent: event.syntheticEvent,
                    });
                }}
            />
        </HeaderThElement>
    );
};

const GridMultiValueCellPage = () => {
    const [filter, setFilter] = useState<CompositeFilterDescriptor | null>(null);
    const filteredData = filter ? filterBy(NonRAGGridDummyData, filter) : NonRAGGridDummyData;
    const columns: GridColumnProps[] = [
        {
            title: 'Adverse event rate',
            locked: false,
            children: [
                {
                    field: 'Score',
                    title: 'Subject Years',
                    filterKey: 'valueInFocus',
                    locked: false,
                    width: 150,
                    cells: {
                        data: (props) => MultiValueDataCell({ ...props, highlighted: true }),
                        filterCell: (props) => <FilterCustomCell {...props} />,
                    },
                    filter: 'numeric',
                    ragColumn: true,
                },
                {
                    field: 'Change',
                    filter: 'numeric',
                    title: 'Change',
                    width: 90,
                    locked: false,
                },
            ],
        },
    ];
    return (
        <CardGrid
            filterable
            filter={filter ?? undefined}
            onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
            data={filteredData}
            title="Multi value cells OPRA Grid"
            maxHeight="800px"
            testDataId="dummy-grid"
            columns={columns}
            gridViewOptions={[]}
            canEdit
            clientGrid
        />
    );
};

export default GridMultiValueCellPage;
